import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined"
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined"
import VoicemailOutlinedIcon from "@mui/icons-material/VoicemailOutlined"
import Chip from "@mui/material/Chip"
import Typography from "@mui/material/Typography"
import { styled } from "@mui/material/styles"
import { formatDistanceToNow } from "date-fns"
import { useNavigate } from "react-router-dom"

import Column from "../../../../common/components/Column"
import Row from "../../../../common/components/Row"
import { trimLongString } from "../../../../common/utils"
import { INBOX_CHANNELS, getInboxMessagesPath } from "./inboxNotificationTypes"

const CHANNEL_META = {
  [INBOX_CHANNELS.email]: { label: "Email", Icon: EmailOutlinedIcon },
  [INBOX_CHANNELS.sms]: { label: "SMS", Icon: SmsOutlinedIcon },
  [INBOX_CHANNELS.voicemail]: {
    label: "Voicemail",
    Icon: VoicemailOutlinedIcon,
  },
}

function formatRelativeTime(value) {
  if (!value) return null
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return null
  return formatDistanceToNow(date, { addSuffix: true })
}

export default function InboxNotificationRow({ notification, onClose }) {
  const navigate = useNavigate()
  const meta = CHANNEL_META[notification.channel] || CHANNEL_META.email
  const TypeIcon = meta.Icon

  function handleClick() {
    onClose?.()
    navigate(getInboxMessagesPath(notification))
  }

  return (
    <NotificationContainer onClick={handleClick}>
      <TypeIconWrap>
        <TypeIcon fontSize="small" color="action" aria-hidden />
      </TypeIconWrap>
      <Column sx={{ width: "100%", gap: 1, minWidth: 0 }}>
        <Row
          sx={{ justifyContent: "space-between", alignItems: "center", gap: 1 }}
        >
          <Typography
            variant="h6"
            sx={{ fontSize: "16px" }}
            noWrap
            title={notification.title}
          >
            {notification.title}
          </Typography>
          <Row sx={{ alignItems: "center", gap: 1, flexShrink: 0 }}>
            <Chip
              size="small"
              label={meta.label}
              sx={{ height: 20, fontSize: 11, fontWeight: 600 }}
            />
            {formatRelativeTime(notification.date) ? (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ fontSize: "0.8em", flexShrink: 0 }}
              >
                {formatRelativeTime(notification.date)}
              </Typography>
            ) : null}
          </Row>
        </Row>
        <Typography variant="body1" sx={{ fontSize: "0.9rem" }}>
          {trimLongString(notification.preview || "", 60)}
        </Typography>
      </Column>
    </NotificationContainer>
  )
}

const NotificationContainer = styled(Row)(({ theme }) => ({
  padding: theme.spacing(2),
  gap: theme.spacing(1),
  cursor: "pointer",
  "&:hover": {
    backgroundColor:
      theme.palette.colors?.lightBackground || theme.palette.action.hover,
  },
}))

const TypeIconWrap = styled(Row)(({ theme }) => ({
  width: 40,
  height: 40,
  borderRadius: "50%",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  alignSelf: "center",
  backgroundColor: theme.palette.action.hover,
}))
